// extracted by mini-css-extract-plugin
export default {"container":"xd-z"};